import React from "react";
import ValueProp from "./VaLuePrp/VaLuePrp.jsx";

function Valuepropostions() {
  return (
    <>
      <ValueProp />
    </>
  );
}

export default Valuepropostions;
